module.exports = __webpack_public_path__ + "img/match.d677e57e.png";